/**
 * Application route paths
 * Centralized constants to avoid hardcoded strings scattered throughout the codebase
 */

export const ROUTES = {
  HOME: '/frontlinebyod',
  DEVICE_SELECTION: '/frontlinebyod/device',
  AUTH_SETUP: '/frontlinebyod/auth-setup',
  COMPANY_PORTAL_INSTALL: '/frontlinebyod/company-portal-install',
  FEEDBACK_THANKS: '/frontlinebyod/feedback-thanks',
  FEEDBACK_SUBMITTED: '/frontlinebyod/feedback-submitted',
  APP_DOWNLOAD: '/frontlinebyod/app-download',
  AUTH_REDIRECT: '/frontlinebyod/auth-redirect',
  RETRY: '/frontlinebyod/retry',
  ERROR: '/frontlinebyod/error',
  LOADING: '/frontlinebyod/loading'
} as const;
